import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface Currency {
    id: number;
    code: string;
    name: string;
    number: string;
    currencyRate: number;
}

export async function getCurrency(currencyId: number): Promise<Currency> {
    return legacyFetch<Currency>(`currencies/${currencyId}`);
}

export async function saveCurrency(currency: Partial<Currency>): Promise<{ id: number } & Currency> {
    const response = await legacyFetch<unknown>('currencies/saveCurrency/', {
        method: 'POST',
        body: JSON.stringify(currency),
    });
    const data = (response as { data?: Currency }).data ?? (response as Currency);
    return data as { id: number } & Currency;
}

export async function deleteCurrency(currencyId: number): Promise<void> {
    await legacyFetch<void>(`currencies/deleteCurrency/${currencyId}`);
}
